import Http from '../lib/http'
import { adaptPublicPlansResponse } from '../views/Subscription/publicPlans.adapter'

let cachedPlans = null
let inFlight = null

export function getCachedPublicPlansCatalog() {
  return cachedPlans
}

export async function fetchPublicPlansCatalog({ force = false } = {}) {
  if (!force && cachedPlans) return { plans: cachedPlans, error: null }
  if (!force && inFlight) return inFlight
  inFlight = (async () => {
    try {
      const response = await Http.get('/api/public/plans')
      const plans = adaptPublicPlansResponse(response?.data)
      if (!plans.length) {
        return { plans: [], error: 'Could not load plan catalog.' }
      }
      cachedPlans = plans
      return { plans, error: null }
    } catch (error) {
      const message = error?.response?.data?.message || error?.message || 'Could not load plan catalog.'
      return { plans: [], error: message }
    } finally {
      inFlight = null
    }
  })()
  return inFlight
}
